import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faSync, faLightbulb, faExclamationTriangle, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

const ActivityFeed: React.FC = () => {
  return (
    <section id="activity-feed" className="mb-8">
      <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-white">Son Aktiviteler</h2>
          <button className="text-purple-400 hover:text-purple-300 transition-colors text-sm">
            Tüm Aktiviteleri Gör
          </button>
        </div>

        <div className="space-y-4">
          <div className="flex items-start space-x-4 p-4 bg-white/5 rounded-xl">
            <div className="w-10 h-10 bg-green-600/20 rounded-xl flex items-center justify-center flex-shrink-0">
              <FontAwesomeIcon icon={faArrowUp} className="text-green-400" />
            </div>
            <div className="flex-1">
              <h4 className="text-white font-medium mb-1">Etkileşim artışı tespit edildi</h4>
              <p className="text-white/70 text-sm mb-2">
                Son Instagram paylaşımınız ortalamadan %40 daha iyi performans gösteriyor
              </p>
              <span className="text-white/50 text-xs">2 dakika önce</span>
            </div>
            <button className="text-green-400 hover:text-green-300 transition-colors">
              <FontAwesomeIcon icon={faExternalLinkAlt} />
            </button>
          </div>

          <div className="flex items-start space-x-4 p-4 bg-white/5 rounded-xl">
            <div className="w-10 h-10 bg-blue-600/20 rounded-xl flex items-center justify-center flex-shrink-0">
              <FontAwesomeIcon icon={faSync} className="text-blue-400" />
            </div>
            <div className="flex-1">
              <h4 className="text-white font-medium mb-1">Veri senkronizasyonu tamamlandı</h4>
              <p className="text-white/70 text-sm mb-2">
                Bağlı tüm sosyal medya hesaplarından veri başarıyla senkronize edildi
              </p>
              <span className="text-white/50 text-xs">15 dakika önce</span>
            </div>
          </div>

          <div className="flex items-start space-x-4 p-4 bg-white/5 rounded-xl">
            <div className="w-10 h-10 bg-purple-600/20 rounded-xl flex items-center justify-center flex-shrink-0">
              <FontAwesomeIcon icon={faLightbulb} className="text-purple-400" />
            </div>
            <div className="flex-1">
              <h4 className="text-white font-medium mb-1">Yeni AI öngörüsü oluşturuldu</h4>
              <p className="text-white/70 text-sm mb-2">
                Facebook'ta maksimum erişim için optimal paylaşım zamanı keşfedildi
              </p>
              <span className="text-white/50 text-xs">1 saat önce</span>
            </div>
            <button className="text-purple-400 hover:text-purple-300 transition-colors">
              <FontAwesomeIcon icon={faExternalLinkAlt} />
            </button>
          </div>

          <div className="flex items-start space-x-4 p-4 bg-white/5 rounded-xl">
            <div className="w-10 h-10 bg-yellow-600/20 rounded-xl flex items-center justify-center flex-shrink-0">
              <FontAwesomeIcon icon={faExclamationTriangle} className="text-yellow-400" />
            </div>
            <div className="flex-1">
              <h4 className="text-white font-medium mb-1">Dikkat gerekli</h4>
              <p className="text-white/70 text-sm mb-2">
                Twitter etkileşimi bu hafta %15 düştü. İçerik stratejisini gözden geçirin.
              </p>
              <span className="text-white/50 text-xs">3 saat önce</span>
            </div>
            <button className="text-yellow-400 hover:text-yellow-300 transition-colors">
              <FontAwesomeIcon icon={faExternalLinkAlt} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ActivityFeed;
